import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { EmployeeLeaveBalanceDto, ManagedProjectDto } from '../../../commonTypes/reports.types';

export interface IGetLeaveBalanceQuery {
    leaveType: string;
    search?: string;
    projectId?: string;
    page: number;
    size: number;
}

const useHttpGetLeaveBalance = (query: IGetLeaveBalanceQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<EmployeeLeaveBalanceDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [managedProjects, setManagedProjects] = useState<ManagedProjectDto[] | undefined>(undefined);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (!query.leaveType) return;

        setIsReady(false);
        const { exec, abort } = absenceReportApi.getEmployeeLeaveBalance({
            query,
            onSuccess: res => {
                setData(res.body.content);
                setTotal(res.body.totalElements);
                setManagedProjects(res.body.managedProjects);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.leaveType, query.search, query.projectId, query.page, query.size]);

    return { data, total, managedProjects, isReady, isError };
};

export default useHttpGetLeaveBalance;
